import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import AppSidebar from "@/components/AppSidebar";
import ImpersonationBanner from "@/components/ImpersonationBanner";
import PendingOrgBanner from "@/components/PendingOrgBanner";
import { useAuth } from "@/lib/auth";
import { Toaster } from "@/components/ui/toaster";

export default function AppLayout() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (user?.must_change_password || user?.mustChangePassword) return <Navigate to="/change-password" replace />;

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <ImpersonationBanner />
      <PendingOrgBanner />
      <div className="flex flex-1 min-h-0">
        <AppSidebar />
        <main className="flex-1 min-w-0">
          <Outlet />
        </main>
      </div>
      <Toaster />
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="border-b border-border bg-card/40">
      <div className="max-w-7xl mx-auto px-8 py-8 flex items-start justify-between gap-6">
        <div>
          <h1 className="serif text-3xl font-medium text-primary">{title}</h1>
          {subtitle && <p className="text-sm text-muted-foreground mt-1.5">{subtitle}</p>}
        </div>
        {children && <div className="flex items-center gap-2">{children}</div>}
      </div>
    </div>
  );
}

export function PageBody({ children }) {
  return <div className="max-w-7xl mx-auto px-8 py-8">{children}</div>;
}
